export const Mapstyles = Object.freeze({
  upToDate: {
    radius: 4,
    fillColor: '#03a55f',
    color: '#43c7cf',
    weight: 0.7,
    opacity: 1,
    fillOpacity: 0.5,
    dashArray: '',
  },
  upToDate_Hover: {
    pane: 'otaPane',
    radius: 8,
    fillColor: '#03a55f',
    color: '#00ffd9',
    weight: 2,
    opacity: 1,
    fillOpacity: 0.5,
    dashArray: '',
  },
  otaRegion: {
    pane: 'otaPane',
    radius: 8,
    color: '#00ffd9',
    weight: 4,
    dashArray: '',
  },
  otaRegion_Hover: {
    pane: 'otaPane',
    radius: 8,
    color: '#00ffd9',
    weight: 6,
    dashArray: '',
  },
  otaRegion_Clicked: {
    pane: 'otaPane',
    radius: 8,
    color: '#00ffd9',
    weight: 4,
    opacity: 1,
    dashArray: '1 7',
  },
  outdated: {
    radius: 8,
    fillColor: '#165567',
    color: '#43c7cf',
    weight: 0.7,
    opacity: 1,
    fillOpacity: 0.5,
    dashArray: '',
  },
  outdated_Hover: {
    pane: 'otaPane',
    radius: 8,
    fillColor: '#165567',
    color: '#00ffd9',
    weight: 2,
    opacity: 1,
    fillOpacity: 0.5,
    dashArray: '',
  },
  cursor_Default: {
    className: 'cursor-default',
  },
  cursor_Click: {
    className: 'cursor-click',
  },
});
